import TeachMeCWTrainer from './TeachMeCWTrainer';
import RandonCharsCWTrainer from './RandonCharsCWTrainer';
import RandonGroupsCWTrainer from './RandonGroupsCWTrainer';
import TopWordsCWTrainer from './TopWordsCWTrainer';
import SequentialTopWordsCWTrainer from './SequentialTopWordsCWTrainer';
import FullTopWordsCWTrainer from './FullTopWordsCWTrainer';
import FullSequentialTopWordsCWTrainer from './FullSequentialTopWordsCWTrainer';
import { MODES } from './constants';

export default function createCwTrainer (className, wpm, 
    farnsworthWpm, useLetters, useNumbers, useSymbols, 
    totalCharRepeats, display, onDisplay) {

    switch (className) {
        case MODES.RANDOM_CHARACTERS.id:{
            return new RandonCharsCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
        case MODES.RANDOM_GROUPS.id : {
            return new RandonGroupsCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
        case MODES.TOP_WORDS.id : {
            return new TopWordsCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
        case MODES.SEQ_TOP_WORDS.id : {
            return new SequentialTopWordsCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
        case MODES.FULL_TOP_WORDS.id : {
            return new FullTopWordsCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
        case MODES.FULL_SEQ_TOP_WORDS.id : {
            return new FullSequentialTopWordsCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
        default : {
            return new TeachMeCWTrainer(wpm, farnsworthWpm, useLetters, useNumbers, useSymbols, totalCharRepeats, display, onDisplay);
        }
    }
}